import './polyfills';

import { InversifyInjector, type IInjector } from '@paperbits/common/injection';
// import { InversifAintInjector as InversifyInjector } from './injection/inversifAintInjector'

import { CommunityRuntimeModule } from './modules/community/community.runtime.module';
import { CoreRuntimeModule } from './modules/core/core.runtime.module';
import { CustomRouter } from './routing/customRouter';
import { initi18n, seti18nLang } from './translations/i18nextTranslations';
import { TamTamyAPIClient } from './cms/client/TamTamyAPIClient';
import { ApiEndpointProvider } from './configuration/apiEndpointProvider';
import type { RouteGuard } from '@paperbits/common/routing/routeGuard';
import type { EventManager } from '@paperbits/common/events/eventManager';
import type { ICMSRuntimeClient } from './cms/client/ICMSRuntimeClient';

document.addEventListener('DOMContentLoaded', () => {
    let resolve: undefined | ((data: IInjector) => void);
    window['globalInjector'] = window.parent['globalInjector'] || new Promise<IInjector>(r => resolve = r);

    initi18n();
    seti18nLang(document.documentElement.lang);

    const designtime: boolean = location.href.includes('designtime=true');
    const injector: IInjector = new InversifyInjector();
    injector.bindModule(new CoreRuntimeModule(designtime));
    injector.bindModule(new CommunityRuntimeModule());
    injector.bindSingletonFactory('router', (ctx) => {
        const routeGuards = ctx.resolve<RouteGuard[]>('routeGuards');
        const eventManager = ctx.resolve<EventManager>('eventManager');
        return new CustomRouter(routeGuards, eventManager);
    });
    injector.bindSingletonFactory<ICMSRuntimeClient>('apiClient', () => {
        const apiEndPointProvider = new ApiEndpointProvider();
        const client = TamTamyAPIClient.build({
            endpoint: apiEndPointProvider.getEndpoint()
        });
        if (designtime) {
            // TODO(legacy_client)
            console.log('design time runtime');
        }
        /*const proxied: ICMSRuntimeClient = {
            getContent: client.getContent.bind(client),
            listContents: client.listContents.bind(client),
            getContentType: client.getContentType.bind(client)
        };*/
        return client;
    });
    injector.resolve('autostart');
    resolve?.(injector);
});
